<script>
	import AccuracyPrompt from "./modals/AccuracyPrompt.svelte";
	import Default from "./modals/Default.svelte";
	import { getExpParams } from "./utils.js";

	export let onClose;
	let interventionType = getExpParams()["intervention-type"];
	let modalShown = localStorage.getItem("modalShown");
</script>

{#if modalShown === "0"}
	{#if interventionType == "accprompt-modal"}
		<AccuracyPrompt {onClose} />
	{:else if interventionType == "default-modal"}
		<Default {onClose} />
	{/if}
{/if}
